import { Pipe, PipeTransform } from '@angular/core';
import { isString } from 'util';

@Pipe({
  name: 'of'
})
export class OfPipe implements PipeTransform {
  transform(value: any, args?: string) {
    let result = value;
    if (isString(result)) {
      result = value.replace(
        /de |del |el |la |los |las |al |con /gi,
        (x: string) => {
          return x.toLowerCase();
        }
      );
    }

    return result;
  }
}
